export const BRANDS = [
  {
    id: 'general',
    name: 'General (all brands)',
    tip: 'Use this chart as a starting point. Always open the brand’s official size guide before ordering.',
  },
  {
    id: 'nike',
    name: 'Nike',
    tip: 'Nike shoes often run slightly small. If you are between sizes, most shoppers size up half a EU size.',
  },
  {
    id: 'adidas',
    name: 'Adidas',
    tip: 'Adidas fits close to standard EU sizing. Ultraboost and Samba lines can feel narrower in the toe box.',
  },
  {
    id: 'zara',
    name: 'Zara',
    tip: 'Zara apparel tends to run slim. EU sizes may feel tighter than UK high-street brands — consider sizing up for relaxed fits.',
  },
  {
    id: 'hm',
    name: 'H&M',
    tip: 'H&M sizes are generally true to EU labels on paper, but cuts vary by line. Check garment measurements in cm on the product page.',
  },
  {
    id: 'asos',
    name: 'ASOS',
    tip: 'ASOS lists multiple brands — always open the sub-brand size chart. ASOS own-brand denim uses UK waist inches.',
  },
  {
    id: 'levis',
    name: "Levi's",
    tip: "Levi's jeans use waist (inches) + length. W/L format (e.g. 32/32) — match waist here, then pick inseam length separately.",
  },
];
